import { cipo } from 'cipo';

cipo.controller('selectStartScreenController',
    function ($scope, $mdDialog, availableStartScreens) {
        $scope.availableStartScreens = availableStartScreens || [];
        $scope.selectedStartScreen = $scope.availableStartScreens.length == 1 ? $scope.availableStartScreens[0] : null;

        $scope.select = function () {
            $mdDialog.hide($scope.selectedStartScreen);
        };
        
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    });